(function () {
    "use strict";

    // @ngInject
    function NetworkSettingsControllerCtor($injector, $scope, $translate, AnalyticsService, UsersManager, NetworkManager,
                                           Enums, AppStates) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkSettingsController';

        this.UsersManager = UsersManager;
        this.NetworkManager = NetworkManager;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;
        AnalyticsService.trackPageView(this, 'NetworkSettings');

        this.newSettings = null; //will hold local copy of the notification_settings, to be saved in the server
        this.newUnsubscribeData = { //holds subscription settings which are saved under user_email_container
            opportunities: false
        };
        this.currUser = this.NetworkManager.getNetworkCurrUser(true);
        this.loading = true;
        this.errorLabel = null;
        this.slider = {
            value: 100,
            options: {
                floor: 25,
                showSelectionBarSingle: true,
                ceil: 175,
                step: 25,
                showTicksValues: true,
                translate: function (value, sliderId, label) {
                    return value + 'mi';

                }.bind(this),
                onEnd: function (id) {
                    if (this.newSettings.notification_radius != this.slider.value) {
                        this.newSettings.notification_radius = this.slider.value;

                        var analyticsArgs = {
                            notification_radius: this.newSettings.notification_radius
                        };

                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_notification_settings_update_radius, analyticsArgs);

                        this.saveSettings();
                    }
                }.bind(this)
            }
        };


        if (this.currUser.notification_settings) {
            this.updateFromNotificationsSettings()
        }

        this._updateFromNotificationsSettings = this.updateFromNotificationsSettings.bind(this);
        this.UsersManager.on('notificationSettingsUpdated', this._updateFromNotificationsSettings);

        this.currUser.on("network_user_success", function () {
            this.handleUserEmailPreferences();
        }.bind(this));

        this.vendorTypes = Enums.SupportedCreativeTypes.map(function (item) {
            return {key: item.key, text: $translate.instant(item.translationEntry)};
        });

        $scope.$on('$destroy', function () {
            this.UsersManager.off('notificationSettingsUpdated', this._updateFromNotificationsSettings);
        }.bind(this));
    }

    Controllers.NetworkSettingsController = Class(Controllers.BaseController, {
        constructor: NetworkSettingsControllerCtor,

        updateFromNotificationsSettings: function updateFromNotificationsSettings() {
            this.newSettings = this.currUser.notification_settings;
            this.slider.value = this.newSettings.notification_radius;
        },

        handleUserEmailPreferences: function updateUserEmailPreferences() {
            if (this.currUser.user_email_container) {
                this.newUnsubscribeData.opportunities = this.currUser.user_email_container.unsubscribe_network_opportunities;
            }
        },

        saveUserEmailPreferences: function saveUserEmailPreferences() {
            if (this.newUnsubscribeData) {
                this.NetworkManager.saveNetworkEmailUnsubscribes(this.currUser, this.newUnsubscribeData).then(function () {
                    this.handleUserEmailPreferences();
                }.bind(this));
            }
        },

        saveSettings: function saveSettings() {
            if (!this.newSettings) {
                return;
            }

            this.UsersManager.updateNotificationSettings(this.newSettings).then(function success(resp) {
                this.newSettings = resp.data.notification_settings;
                // this.slider.value = this.newSettings.notification_radius;

            }.bind(this)).catch(function error() {
                this.errorLabel = 'SAVING_MODEL_MESSAGE._ERROR_';
            }.bind(this));
        },

        toggleNotificationSettings: function toggleNotificationSettings(key, isChecked) {
            if (!this.newSettings) {
                return;
            }

            this.saveSettings();
        },

        toggleEmailSubscription: function toggleEmailSubscription() {
            this.saveUserEmailPreferences();
        },

        saveNotificationRadius: function saveNotificationRadius() {
            this.saveSettings();
        },

        handleVendorTypeClick: function handleVendorTypeClick(type) {
            if (!this.newSettings) {
                return;
            }

            var key = type.key;
            var index = this.newSettings.subscribed_vendor_types.indexOf(key);

            if (index > -1) {
                // prevents user from setting 0 types
                if (this.newSettings.subscribed_vendor_types.length === 1) {
                    // console.log('no! ✊');
                    // should show user feedback and explanation
                    return;
                } else {
                    this.newSettings.subscribed_vendor_types.splice(index, 1);
                }
            } else {
                this.newSettings.subscribed_vendor_types.push(key);
            }

            this.saveSettings();
        },

        isVendorTypeSelected: function isVendorTypeSelected(type) {
            if (!this.newSettings) {
                return false;
            }
            return Boolean(this.newSettings.subscribed_vendor_types.indexOf(type.key) > -1);
        }
    });
}());
